// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from '@/store/index'
//引用公共方法
import utils from '@/util/util.js'
import mixin from './mixin/mixin'
import vueWaves from '@/util/waves.js'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/util/dialogTop'
Vue.use(vueWaves)
Vue.prototype.mixin = mixin;
Vue.prototype.utils=utils;
Vue.use(ElementUI)
// 全局配置Message组件，设置默认延迟关闭时间为5秒
import { Message } from 'element-ui'
// 保留原始Message对象的所有方法
// 简化版全局配置Message组件，设置默认延迟关闭时间为3秒
// 创建主要调用函数
Vue.prototype.$message = function(options) {
  // 处理字符串参数情况
  if (typeof options === 'string') {
    options = {
      message: options,
      duration: 3000
    }
  } else if (options) {
    // 确保设置默认duration
    options.duration = options.duration || 3000
  }
  return Message(options)
}

// 添加各类型方法
const methods = ['info', 'success', 'warning', 'error']
methods.forEach(type => {
  Vue.prototype.$message[type] = function(options) {
    if (typeof options === 'string') {
      options = {
        message: options,
        duration: 3000
      }
    } else if (options) {
      options.duration = options.duration || 3000
    }
    return Message[type](options)
  }
})

// 添加静态方法
Vue.prototype.$message.closeAll = Message.closeAll
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js